import { groupBy, orderBy } from "lodash";
import { Item__Atividades } from "../../../../../../../services/atividades/GET";
import { obterCodInsumoDashboard, obterNomeMediaLocal } from "../../insumosPrecisao/meta";

export function normarlizarEmLitros(quantidade: number, cod_medida: number) {
    //já está em L
    if (cod_medida === 1) {
        return quantidade;
    }

    //transformar mL em L
    if (cod_medida === 2) {
        return quantidade / 1000;
    }

    //TODO
    //precisa tratar quando a medida for dose/ha

    return 0;
}

export function obterListaInsumosLiquidos(todas_atividades_ativas: Item__Atividades[]) {

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i, andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo
                        }
                    })
                }
            })
        }
    }).filter(i => i.delete_time === null);

    const apenas_insumos = (incluir_tipo_atv ?? []).map(i => {
        return i.andamentos.map(j => {
            return (j.insumos ?? []).map(k => {
                return {
                    cod: k.cod,
                    insumo_nome: k.insumo_nome,
                    cod_produto: k.cod_produto,
                    cod_fertilizante: k.cod_fertilizante,
                    cod_tecnologia: k.cod_tecnologia,
                    cod_variedade_hibrido: k.cod_variedade_hibrido,
                    cod_tipo: k.cod_tipo,
                    cod_tipo_atividade: k.cod_tipo_atividade,
                    composicao: k.composicao,
                    cod_medida: k.cod_medida,
                    dosagem: k.dosagem,
                    maximo_abaixo: k.maximo_abaixo,
                    maximo_acima: k.maximo_acima,
                    quantidade: k.quantidade,
                    tipo_atividade: k.tipo_atividade,
                    nome_medida_filtro: obterNomeMediaLocal(k.cod_medida).nome_filtro,
                    tipo_fisico_medida: obterNomeMediaLocal(k.cod_medida).tipo_fisico,
                    cod_insumo: obterCodInsumoDashboard(k)
                    // nome_medida_completo: obterNomeMediaLocal(k.cod_medida).nome_completo,
                }
            })
        })
        //@ts-ignore
    }).flat(2)?.filter(i => i.cod_tipo !== 8 && i.cod_tipo !== 9);

    const insumos_liquidos = apenas_insumos.filter(i => i.tipo_fisico_medida === "Líquido");

    const incluir_qtd_normalizada_em_litros = (insumos_liquidos ?? []).map(i => {
        return {
            ...i,
            quantidade_em_litros: normarlizarEmLitros(i.quantidade, i.cod_medida)
        }
    });

    const insumos_planejados = (incluir_qtd_normalizada_em_litros ?? []).filter(({ tipo_atividade }) => tipo_atividade === "planejada");
    const insumos_executados = (incluir_qtd_normalizada_em_litros ?? []).filter(({ tipo_atividade }) => tipo_atividade === "executada");

    const agrupar_insumos_planejados = groupBy(insumos_planejados, "insumo_nome");
    const agrupar_insumos_executados = groupBy(insumos_executados, "insumo_nome");

    const totalizar_planejados = Object.entries(agrupar_insumos_planejados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const totalizar_executados = Object.entries(agrupar_insumos_executados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_litros, 0)
        }
    });

    const insumos_consolidados: {
        cod_insumo: number | null;
        insumo_nome: string;
        quantidade_planejada: number;
        quantidade_executada: number;
        precisao: number;
        porcentagem: number;
        ordem: number;
    }[] = [];

    // Combine planned and executed data
    const todos_insumos = new Set([...totalizar_planejados.map(i => i.insumo_nome), ...totalizar_executados.map(i => i.insumo_nome)]);

    todos_insumos.forEach(insumo_nome => {
        const primeiro_insumo = (agrupar_insumos_planejados[insumo_nome] || agrupar_insumos_executados[insumo_nome])?.[0];
        const cod_insumo = primeiro_insumo?.cod_insumo || null;

        const planejado = totalizar_planejados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;
        const executado = totalizar_executados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;

        let precisao = 0;
        let porcentagem = 0;

        if (planejado > 0) {
            const porcentagem_realizada = (executado / planejado) * 100;

            // Precision: 100 - |100 - executed%|
            // Represents how close the execution was to the plan (0-100%)
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;

            // Bar Percentage: Visual representation of execution.
            // As per user request: "não precisa compensar os 80%, pode exibir o valor real mesmo"
            // Example: 105% executed -> 105% bar.
            porcentagem = porcentagem_realizada;

        } else if (executado > 0) {
            precisao = 0;
            // Unplanned execution -> Percentage and Precision must be 0 as per user request.
            porcentagem = 0;
        }

        insumos_consolidados.push({
            cod_insumo,
            insumo_nome,
            quantidade_planejada: Number(planejado?.toFixed(2)),
            quantidade_executada: Number(executado?.toFixed(2)),
            precisao: Number(precisao?.toFixed(2)),
            porcentagem: Number(porcentagem?.toFixed(2)),
            ordem: (planejado > 0 && executado > 0) ? 1 : (planejado === 0 && executado > 0) ? 2 : (planejado > 0 && executado === 0) ? 3 : 4
        });
    });

    return orderBy(insumos_consolidados, ["ordem", "quantidade_executada"], ["asc", "desc"]) ?? [];

}